function Disclaimer() {
  return (
    <div className="px-5 mx-auto mt-5 max-w-7xl">
      <div className="text-center text-2xl font-semibold mt-6">Disclaimer</div>
      <h4 className=" text-primaryDark mt-6">
        <span className="font-semibold">Interpretation and Definitions</span>
      </h4>
      <div className="mt-5">
        <p className="text-sm text-gray-500">
          Interpretation The words of which the initial letter is capitalized
          have meanings defined under the following conditions. The following
          definitions shall have the same meaning regardless of whether they
          appear in singular or in plural.
        </p>
        <br />
        <p className="text-sm text-gray-500">
          <div className="text-md font-medium mb-1 underline">
            Definitions For the purposes of this Disclaimer:{" "}
          </div>
          • Company (referred to as either "the Company", "We", "Us" or "Our" in
          this Disclaimer) refers to Prem Seva Ltd , 3 Almond glade, Wickersley,
          Rotherham S66 1JZ. <br />• Service refers to the Website or the
          Application or both. <br />• You means the individual accessing the
          Service, or the company, or other legal entity on behalf of which such
          individual is accessing or using the Service, as applicable.
          <br /> • Website refers to Prem Seva, accessible from premseva.com{" "}
          <br />• Application means the software program provided by the Company
          downloaded by You on any electronic device named Prem Seva.
        </p>
        <br />
      </div>
      <h4 className=" text-primaryDark ">
        <span className="font-semibold">Disclaimer</span>
      </h4>
      <div className="mt-5">
        <p className="text-sm text-gray-500">
          The information contained on the Service is for general information
          purposes only. The Company assumes no responsibility for errors or
          omissions in the contents of the Service. In no event shall the
          Company be liable for any special, direct, indirect, consequential, or
          incidental damages or any damages whatsoever, whether in an action of
          contract, negligence or other tort, arising out of or in connection
          with the use of the Service or the contents of the Service. The
          Company reserves the right to make additions, deletions, or
          modifications to the contents on the Service at any time without prior
          notice. The Company does not warrant that the Service is free of
          viruses or other harmful components.
        </p>
        <br />
      </div>
      <h4 className=" text-primaryDark ">
        <span className="font-semibold">Medical Information Disclaimer</span>
      </h4>
      <div className="mt-5">
        <p className="text-sm text-gray-500">
          The information about health provided by the Service is not intended
          to diagnose, treat, cure or prevent disease. Products, services,
          information and other content provided by the Service, including
          information linking to third-party websites are provided for
          informational purposes only. Information offered by the Service is not
          comprehensive and does not cover all diseases, ailments, physical
          conditions or their treatment. Individuals are different and may react
          differently to different products. Comments made on the Service by
          employees or other users are strictly their own personal views made in
          their own personal capacity and are not claims made by the Company nor
          do they represent the position or view of the Company. The Company is
          not liable for any information provided by the Service with regard to
          recommendations regarding supplements for any health purposes. The
          Company makes no guarantee or warranty with respect to any products or
          services sold. The Company is not responsible for any damages for
          information or services provided even if the Company has been advised
          of the possibility of damages.
        </p>
        <br />
      </div>
      <h4 className=" text-primaryDark ">
        <span className="font-semibold">
          Fitness & Nutritional Information Disclaimer
        </span>
      </h4>
      <div className="mt-5">
        <p className="text-sm text-gray-500">
          The Service can offer health, fitness and nutritional information
          including, without limitation, advice and recommendation, that is
          provided solely as general education and informational purposes. Use
          of the advice and information contained herein is at your sole choice
          and risk. You should not rely on this information as a substitute for,
          nor does it replace, professional medical advice, diagnosis, or
          treatment. Always consult your physician or healthcare provider before
          beginning any nutrition or exercise program. If You choose to use this
          information without prior consent of your physician, You are agreeing
          to accept full responsibility for your decisions and agreeing to hold
          harmless the Company.
        </p>
        <br />
      </div>
      <h4 className=" text-primaryDark ">
        <span className="font-semibold">External Links Disclaimer</span>
      </h4>
      <div className="mt-5">
        <p className="text-sm text-gray-500">
          The Service may contain links to external websites that are not
          provided or maintained by or in any way affiliated with the Company.
          Please note that the Company does not guarantee the accuracy,
          relevance, timeliness, or completeness of any information on these
          external websites.
        </p>
        <br />
      </div>{" "}
      <h4 className=" text-primaryDark ">
        <span className="font-semibold">Errors and Omissions Disclaimer</span>
      </h4>
      <div className="mt-5">
        <p className="text-sm text-gray-500">
          The information given by the Service is for general guidance on
          matters of interest only. Even if the Company takes every precaution
          to ensure that the content of the Service is both current and
          accurate, errors can occur. Plus, given the changing nature of laws,
          rules and regulations, there may be delays, omissions or inaccuracies
          in the information contained on the Service. The Company is not
          responsible for any errors or omissions, or for the results obtained
          from the use of this information.
        </p>
        <br />
      </div>{" "}
      <h4 className=" text-primaryDark ">
        <span className="font-semibold">Fair Use Disclaimer</span>
      </h4>
      <div className="mt-5">
        <p className="text-sm text-gray-500">
          The Company may use copyrighted material which has not always been
          specifically authorized by the copyright owner. The Company is making
          such material available for criticism, comment, news reporting,
          teaching, scholarship, or research. The Company believes this
          constitutes a "fair use" of any such copyrighted material as provided
          for in section 107 of the United States Copyright law. If You wish to
          use copyrighted material from the Service for your own purposes that
          go beyond fair use, You must obtain permission from the copyright
          owner.
        </p>
        <br />
      </div>
      <h4 className=" text-primaryDark ">
        <span className="font-semibold"></span>
      </h4>
      <div className="mt-5">
        <p className="text-sm text-gray-500"></p>
      </div>
      <h4 className=" text-primaryDark ">
        <span className="font-semibold">Views Expressed Disclaimer</span>
      </h4>
      <div className="mt-5">
        <p className="text-sm text-gray-500">
          The Service may contain views and opinions which are those of the
          authors and do not necessarily reflect the official policy or position
          of any other author, agency, organization, employer or company,
          including the Company. Comments published by users are their sole
          responsibility and the users will take full responsibility, liability
          and blame for any libel or litigation that results from something
          written in or as a direct result of something written in a comment.
          The Company is not liable for any comment published by users and
          reserves the right to delete any comment for any reason whatsoever.
        </p>
        <br />
      </div>
      <h4 className=" text-primaryDark ">
        <span className="font-semibold">No Responsibility Disclaimer</span>
      </h4>
      <div className="mt-5">
        <p className="text-sm text-gray-500">
          The information on the Service is provided with the understanding that
          the Company is not herein engaged in rendering legal, accounting, tax,
          or other professional advice and services. As such, it should not be
          used as a substitute for consultation with professional accounting,
          tax, legal or other competent advisers. In no event shall the Company
          or its suppliers be liable for any special, incidental, indirect, or
          consequential damages whatsoever arising out of or in connection with
          your access or use or inability to access or use the Service.
        </p>
        <br />
      </div>{" "}
      <h4 className=" text-primaryDark ">
        <span className="font-semibold">"Use at Your Own Risk" Disclaimer</span>
      </h4>
      <div className="mt-5">
        <p className="text-sm text-gray-500">
          All information in the Service is provided "as is", with no guarantee
          of completeness, accuracy, timeliness or of the results obtained from
          the use of this information, and without warranty of any kind, express
          or implied, including, but not limited to warranties of performance,
          merchantability and fitness for a particular purpose. The Company will
          not be liable to You or anyone else for any decision made or action
          taken in reliance on the information given by the Service or for any
          consequential, special or similar damages, even if advised of the
          possibility of such damages.
        </p>
        <br />
      </div>
      <h4 className=" text-primaryDark ">
        <span className="font-semibold">Contact Us</span>
      </h4>
      <div className="mt-5">
        <p className="text-sm text-gray-500">
          If you have any questions about this Disclaimer, You can contact Us:
        </p>
        <p className="text-sm text-[#0566B1] font-medium ">
          By email: <span className="underline">premsevateam@gmail.com</span>
        </p>
        <p className="text-sm text-[#0566B1] font-medium">
          By visiting this page on our website: <span className="underline">premseva.com</span>
        </p>
        <br />
      </div>
    </div>
  );
}

export default Disclaimer;
